import type { JSX } from "react";
import { Term } from "../Term";

export function MiniStat({ label, value, tone }: { label: string; value: string; tone?: "ok" | "warn" | "err" }): JSX.Element {
  const cls = tone ? ` cc-ministat-${tone}` : "";
  return (
    <div className={`cc-ministat${cls}`}>
      <span className="cc-ministat-value">{value}</span>
      <span className="cc-ministat-label"><Term>{label}</Term></span>
    </div>
  );
}
